export const PHYSICAL_ATTRIBUTES = [
  'Acne',
  'Amputee',
  'Blind',
  'Braces',
  'Cerebral Palsy',
  'Crutches/Cane User',
  'Dark Circles',
  'Deaf',
  'Dentures',
  'Double Mastectomy',
  'Down Syndrome',
  'Dwarfism',
  'Eczema',
  'Fine Lines',
  'Facial Scar',
  'Glass Eye',
  'Hard of Hearing',
  'Hyperpigmentation',
  'Keratosis Pilaris',
  'Mobility Disability',
  'Neurodiverse',
  'Paraplegic',
  'Prosthetic Arm',
  'Prosthetic Foot',
  'Prosthetic Hand',
  'Prosthetic Leg',
  'Quadriplegic',
  'Scars',
  'SingleMastectomy',
  'Stretch Marks',
  'Varicose Veins',
  'Wheelchair User',
  'Willing to cut hair',
  'Willing to get botox',
  'Willing to get botox + filler',
  'Willing to get filler',
  'Willing to get other aesthetic changes',
];
